import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import AbstractPopupMediator from "../../../../../shared/src/ranj/app/ui/AbstractPopupMediator";


export default class FinishMediator extends AbstractPopupMediator {

    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameConfig) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
        this._gameConfig = gameConfig;
    }

    initialize() {
        super.initialize();
        this.anchorObject(this._target, Anchor.T);
        this.createTween(this._target.finish, 0, this.onComplete.bind(this));
    }



    createTween(obj, delay, onComplete) {
        const scaleOrig = obj.scaleX;
        obj.visible = false;
        obj.alpha = 1;
        obj.scaleX = obj.scaleY = scaleOrig * .1;
        return createjs.Tween.get(obj)
            .wait(delay)
            .set({ visible: true })
            .to({ alpha: 1, scaleX: scaleOrig, scaleY: scaleOrig }, 600, createjs.Ease.bounceOut)
            .wait(1000)
            .call(onComplete)
            .to({ alpha: 0, scaleX: scaleOrig * 2, scaleY: scaleOrig * 2 }, 300, createjs.Ease.linear);
    }

    onComplete() {
        let onClose = this._target.onClose;
        if (onClose != null) {
            onClose();
        }
        this._target.onClose = null;
        this.callDelayed(this.close.bind(this), 500);
    }
};
